// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__24QUG","detailsBorder":"styles_detailsBorder__8KsQd"};